module.exports = __webpack_public_path__ + "img/people.911e79e2.svg";